/**
 * @generated SignedSource<<bf488b51a532c68401371fbdc22e2a6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactTeamMemberInlineFragment$data = {
  readonly id: string;
  readonly teamMember: {
    readonly id: string;
    readonly memberUserProfile: {
      readonly firstName: string;
      readonly lastName: string;
    };
  };
  readonly fee: {
    readonly " $fragmentSpreads": FragmentRefs<"feeInlineFragment">;
  } | null;
  readonly " $fragmentType": "contactTeamMemberInlineFragment";
};
export type contactTeamMemberInlineFragment$key = {
  readonly " $data"?: contactTeamMemberInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactTeamMemberInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactTeamMemberInlineFragment"
};

(node as any).hash = "229c8b4719d8cccb28161ef866fd246f";

export default node;
